import styled from "styled-components";

export const Celula = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  min-width: 0;

  .texto {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Chip = styled.span`
  flex-shrink: 0;
  padding: 3px 11px;
  border-radius: 50px;
  background-color: #f5f5f5;
  border: 1px solid #7f7f7f;
  color: #7f7f7f;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
`;
